/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { ErrorHandler, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorsService } from './errors.service';
import { ErrorTranslationService } from './error-translation.service';

@Injectable()
export class ApplicationErrorHandler extends ErrorHandler {

  constructor(private errorsService: ErrorsService,
              private errorTranslationService: ErrorTranslationService
  ) {
    super()
  }

  override handleError(error: any): void {
    if (error instanceof HttpErrorResponse) {
      super.handleError(error);
    } else {

      const message: string = error?.message
      const description: string = error?.stack
      const defaultMessage = 'defaultError';
      const defaultDescription: string = error;

      super.handleError(error);
      this.errorTranslationService.translateAndShowSimpleException(message, description, defaultMessage, defaultDescription);
      this.errorsService.prepareAndSaveException(error, 'frontend', 'frontend')

    }
  }
}
